export const MAP_EVENTS = Object.freeze({
  EXECUTIVE: 'map:executive',
  EXECUTIVE_ENTITY_SELECTED: 'map:executive-entity-selected',
  ZONE: 'map:zone'
})
